import React, {Fragment, useState} from 'react';
import {googleMapsApiKey} from "../../env";
import {GoogleMap, LoadScript, Marker, Circle, InfoWindow} from '@react-google-maps/api';
import {getMediaThumbSrc} from "../../helpers/mediaUrl";
import mapSpotGroup from '../../assets/icons/map-spot-group.svg'
import mapStand from '../../assets/icons/map-stand.svg'
import mapHistory from '../../assets/icons/map-history.svg'
import useBookable from "../../hooks/useBookable";
import useFunction from "../../hooks/useFunction";

const MapBookable = (props) => {
  const {bookable} = props
  const {isSpotGroup, isStand} = useBookable()
  const {date} = useFunction()
  const [activeHistoryMarker, setActiveHistoryMarker] = useState(null)

  const hasCoords = bookable.lat && bookable.lng
  const showMap = (isSpotGroup(bookable) && hasCoords) || (isStand(bookable) && hasCoords && bookable.radius)

  if (!showMap) return null

  const coordinates = {
    lat: parseFloat(bookable.lat),
    lng: parseFloat(bookable.lng),
  }

  // Location history entries with coordinates
  const historyEntries = (bookable.location_history || []).filter(e => e.lat && e.lng)

  const formatDateRange = (entry) => {
    const parts = []
    if (entry.date_from) parts.push(date(entry.date_from))
    if (entry.date_to) parts.push(date(entry.date_to))
    return parts.length === 2 ? parts[0] + ' t/m ' + parts[1] : parts[0] || null
  }

  return (
    <div className="component-map-bookable">
      <LoadScript googleMapsApiKey={googleMapsApiKey}>
        <GoogleMap
          mapContainerClassName={'map-container-inner'}
          zoom={8}
          center={coordinates}
          clickableIcons={false}
          options={{streetViewControl: false}}
        >
          {/* Main bookable marker */}
          <Fragment key={bookable.id}>
            <Marker
              position={coordinates}
              icon={isSpotGroup(bookable) ? mapSpotGroup : mapStand}
            />
            {bookable.radius &&
              <Circle
                center={coordinates}
                radius={bookable.radius * 1000}
                options={{strokeColor: "#58AD50"}}
              />
            }
          </Fragment>

          {/* Location history markers */}
          {historyEntries.map((entry) => (
            <Fragment key={'history-' + entry.id}>
              <Marker
                position={{lat: parseFloat(entry.lat), lng: parseFloat(entry.lng)}}
                icon={mapHistory}
                onMouseOver={() => setActiveHistoryMarker(entry.id)}
                onClick={() => setActiveHistoryMarker(activeHistoryMarker === entry.id ? null : entry.id)}
              />
              {activeHistoryMarker === entry.id &&
                <InfoWindow
                  position={{lat: parseFloat(entry.lat), lng: parseFloat(entry.lng)}}
                  onCloseClick={() => setActiveHistoryMarker(null)}
                >
                  <div className="location-history-info-window">
                    {getMediaThumbSrc(entry.media) &&
                      <img src={getMediaThumbSrc(entry.media)} alt={entry.label}/>
                    }
                    <div className="info-content">
                      <strong>{entry.label}</strong>
                      {entry.city && <p className="info-city">{entry.city}</p>}
                      {formatDateRange(entry) && <p className="info-dates">{formatDateRange(entry)}</p>}
                      {entry.description && <p className="info-description">{entry.description}</p>}
                    </div>
                  </div>
                </InfoWindow>
              }
            </Fragment>
          ))}
        </GoogleMap>
      </LoadScript>
    </div>
  )
}

const isEqual = () => true

export default React.memo(MapBookable, isEqual)
